export const createRetryingImageUrlCreator = (sourceUrl) => {
    return (_uuid, _imageSize, _effect, _rotation, _watermark, retryCount) => {
        const url = new URL(sourceUrl, window.location.href);
        if (retryCount && retryCount > 0) {
            url.searchParams.set("retry", String(retryCount));
        }
        else {
            url.searchParams.delete("retry");
        }
        return url.toString();
    };
};
const getUserImageUrlParamsAsString = (uuid, imageSize, effect, rotation, watermark, retryCount) => {
    let type = 0;
    console.log("Epms image effect", effect);
    switch (effect) {
        case "original":
            type = 0;
            break;
        case "bw":
            type = 1;
            break;
        case "sepia":
            type = 2;
            break;
    }
    let params = `?uuid=${uuid}&scaleversion=${imageSize}&type=${type}&rotation=${rotation}`;
    if (imageSize > 800) {
        params += "&or=1";
    }
    if (!watermark) {
        params += "&nowm";
    }
    if (retryCount && retryCount > 0) {
        params += "&retry=" + retryCount;
    }
    return params;
};
export const webshopUserImageUrlCreator = (uuid, imageSize = 640, effect, rotation, watermark, retryCount) => {
    let url = `${window.location.protocol}//${window.location.host}/system/xphoto/webshop`;
    url += getUserImageUrlParamsAsString(uuid, imageSize, effect, rotation, watermark, retryCount);
    return url;
};
export const adminUserImageUrlCreator = (uuid, imageSize = 640, effect, rotation, watermark, retryCount) => {
    let url = `${window.location.protocol}//${window.location.host}/admin/_xphoto`;
    url += getUserImageUrlParamsAsString(uuid, imageSize, effect, rotation, watermark, retryCount);
    if (imageSize > 0) {
        url += "&nowait=1";
    }
    return url;
};
export const storybookImageUrlCreator = (uuid, imageSize = 640, effect, rotation, watermark, retryCount) => {
    return `/images/${uuid}`;
};
